export default __webpack_public_path__ + "static/media/alexander-shatov-71Qk8ODIBko-unsplash.b8fdfa2b.jpg";